import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { mutateUiAdminConfigKeys } from './mutateKeyFactory';
import { uiAdminConfigsKeys } from './queryKeyFactory';
import { GearUiAdminConfigType } from '../../Model/uiAdminConfig/GearUiAdminConfigType';
import { configurationKeys } from '../configuration/queryKeyFactory';
import { GLOBAL_FILTERS_LIMIT_KEY_PREFIX, MULTI_FILE_UPLOAD_LIMIT_KEY_PREFIX } from '../../config/consts';

export function useUpsertUiAdminConfigEntry(): UseMutationResult<
  void,
  unknown,
  {
    key: GearUiAdminConfigType;
    body: string;
  }
> {
  const servicesCtx = useContext(ServicesContext);
  const queryClient = useQueryClient();

  const upsertUiAdminConfigEntry = (data: { key: GearUiAdminConfigType; body: string }) => {
    if (servicesCtx?.uiAdminConfigsService) {
      return servicesCtx.uiAdminConfigsService.upsertUiAdminConfigEntry(data.key, data.body);
    }
    throw new Error('Services context not initialized');
  };

  return useMutation({
    mutationKey: mutateUiAdminConfigKeys.upsertUiAdminConfigEntry,
    mutationFn: upsertUiAdminConfigEntry,
    onSuccess: async (
      _,
      variables: {
        key: GearUiAdminConfigType;
        body: string;
      }
    ) => {
      await queryClient.invalidateQueries({ queryKey: uiAdminConfigsKeys.uiAdminConfigByKey(variables.key) });

      if (variables.key.startsWith(GLOBAL_FILTERS_LIMIT_KEY_PREFIX)) {
        const indexId = parseInt(variables.key.replace(GLOBAL_FILTERS_LIMIT_KEY_PREFIX, ''));
        await queryClient.invalidateQueries({ queryKey: configurationKeys.globalFiltersLimit(indexId) });
      }

      if (variables.key.startsWith(MULTI_FILE_UPLOAD_LIMIT_KEY_PREFIX)) {
        const indexId = parseInt(variables.key.replace(MULTI_FILE_UPLOAD_LIMIT_KEY_PREFIX, ''));
        await queryClient.invalidateQueries({ queryKey: configurationKeys.multiFileUploadLimit(indexId) });
      }
    }
  });
}
